import { defineStore } from "pinia";
import axiosInstance from "@/config/axios";

const mapBoostProductOption = (product) => {
    if (!product || product.id == null) {
        return null;
    }

    const name =
        product.name != null && String(product.name).trim() !== ""
            ? String(product.name)
            : String(product.id);

    return {
        ...product,
        name,
        _searchLabelLower: name.toLowerCase(),
    };
};

const mapCampaignRow = (campaign) => ({
    ...campaign,
    active: campaign.status !== 0,
});

export const useProductAdStore = defineStore("ProductAd", {
    state: () => {
        return {
            productAdInsights: [],
            productAdInsightsCategories: [],
            productAdInsightsCategoriesLoading: false,
            productAdInsightsCategoriesOrderBy: null,
            productAdInsightsCategoriesSortBy: null,
            productAdInsightsLoading: false,
            productAds: [],
            productAdsLoading: false,
            campaigns: [],
            campaignsLoading: false,
            boostProducts: [],
            boostProductsLoading: false,
            productAdBoostLoading: false,
        };
    },
    getters: {},
    actions: {
        async fetchProductAds({ shopId }) {
            return axiosInstance.get(`/v1/product-ad/${shopId}`).then((response) => {
                this.productAds = response.data;
            });
        },

        async updateCreateProductAd({ data, shopId }) {
            return axiosInstance.post(`/v1/product-ad/update-create/${shopId}`, data);
        },

        async disableEnableProductAds({ data, shopId }) {
            return axiosInstance.post(`/v1/product-ad/disable-enable/${shopId}`, data);
        },

        async getBrands({ shopId }) {
            return axiosInstance.get(`/v1/product-ad/brands/${shopId}`);
        },

        async getMaxCpc({ data, shopId }) {
            return axiosInstance.get(`/v1/product-ad/max-cpc/${shopId}`, {
                params: data,
            });
        },

        async fetchInsights({ data, shopId }) {
            return this.fetchInsightsPlot({ data, shopId }).then((response) => {
                if (response !== undefined) {
                    this.productAdInsights = response.data;
                }
            });
        },

        async fetchInsightsPlot({ shopId, data }) {
            return axiosInstance.get(`/v1/product-ad/insights/${shopId}`, {
                params: data,
            });
        },

        async fetchInsightsCategories({ data, shopId }) {
            return axiosInstance
                .get(`/v1/product-ad/insights-categories/${shopId}`, {
                    params: data,
                })
                .then((response) => {
                    this.productAdInsightsCategories = response.data;
                });
        },

        async fetchCampaigns({ shopId }) {
            this.campaignsLoading = true;

            return axiosInstance
                .get(`/product-ads/get-campaigns/${shopId}`)
                .then((response) => {
                    this.campaigns = (response.data || []).map(mapCampaignRow);
                })
                .finally(() => {
                    this.campaignsLoading = false;
                });
        },

        async fetchBoostProducts({ shopId }) {
            this.boostProductsLoading = true;

            return axiosInstance
                .get(`/v1/coupon/products/${shopId}`)
                .then((response) => {
                    this.boostProducts = (response.data || [])
                        .map(mapBoostProductOption)
                        .filter(Boolean);
                })
                .finally(() => {
                    this.boostProductsLoading = false;
                });
        },

        async storeCampaign({ payload, campaignId = null }) {
            const url = campaignId
                ? `/product-ads/store-campaign/${campaignId}`
                : "/product-ads/store-campaign";

            return axiosInstance.post(url, payload);
        },

        async deleteCampaign(campaignId) {
            return axiosInstance.delete(`/product-ads/campaign/${campaignId}`);
        },

        async enableDisableCampaign({ campaign_id, disabled }) {
            return axiosInstance.post("/product-ads/enable-disable-campaign", {
                campaign_id,
                disabled,
            });
        },
    },
});
